import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {TextboxComponent} from "./textbox.component";
import {NgSelectModule} from "@ng-select/ng-select";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        FormsModule,
        NgSelectModule
    ],
    declarations: [
        TextboxComponent
    ],
    exports: [
        TextboxComponent
    ]
})

export class TextboxModule {
}
